import { Box, Text } from '@primer/react';
import { ArrowRightIcon } from '@primer/octicons-react';
import Reveal from './Reveal';
import { CALENDLY_URL, trackContactClick } from '../utils/links';

function ServiceCTA({ eyebrow, headline, subtitle }) {
  return (
    <Box
      sx={{
        position: 'relative',
        width: '100%',
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'canvas.default',
        backgroundImage:
          'radial-gradient(circle at 50% 40%, rgba(96, 165, 250, 0.14), transparent 60%)',
        paddingX: 4,
        overflow: 'hidden',
      }}
    >
      <Reveal sx={{ maxWidth: '760px', textAlign: 'center' }}>
        <Text
          as="p"
          sx={{
            margin: 0,
            marginBottom: 3,
            fontFamily: "'Fraunces', serif",
            fontStyle: 'italic',
            fontSize: 2,
            color: 'accent.fg',
          }}
        >
          {eyebrow}
        </Text>

        <Box sx={{ marginBottom: 4 }}>
          {headline.map((line) => (
            <Text
              key={line.text}
              as="p"
              sx={{
                margin: 0,
                fontFamily: "'Fraunces', serif",
                fontWeight: 300,
                fontSize: ['2rem', '2.75rem', '3.5rem'],
                lineHeight: 1.2,
                color: line.tone === 'gradient' ? undefined : 'fg.default',
                backgroundImage: line.tone === 'gradient' ? 'linear-gradient(90deg, #8ec5ff, #c4b5fd)' : undefined,
                backgroundClip: line.tone === 'gradient' ? 'text' : undefined,
                WebkitBackgroundClip: line.tone === 'gradient' ? 'text' : undefined,
                WebkitTextFillColor: line.tone === 'gradient' ? 'transparent' : undefined,
              }}
            >
              {line.text}
            </Text>
          ))}
        </Box>

        <Text
          as="p"
          sx={{
            margin: 0,
            marginBottom: 5,
            fontSize: 2,
            lineHeight: 1.7,
            color: 'fg.muted',
          }}
        >
          {subtitle}
        </Text>

        <Box
          as="a"
          href={CALENDLY_URL}
          target="_blank"
          rel="noopener noreferrer"
          onClick={trackContactClick}
          sx={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 2,
            paddingX: 5,
            paddingY: 3,
            borderRadius: '6px',
            border: '1px solid rgba(27, 31, 36, 0.15)',
            backgroundColor: '#1f883d',
            color: '#ffffff',
            fontSize: 2,
            fontWeight: 600,
            textDecoration: 'none',
            transition: 'background-color 0.15s ease',
            ':hover': { backgroundColor: '#1c8139' },
            ':active': { backgroundColor: '#197935' },
          }}
        >
          Schedule a Consultation
          <ArrowRightIcon size={18} />
        </Box>
      </Reveal>
    </Box>
  );
}

export default ServiceCTA;
